import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class PslPerformance extends ApplicationRecord {
  static jsonapiType = "psl_performances";

  @Attr() id: string;
  @Attr() agencyName: string;
  @Attr() hhScore: string;
  @Attr() primaryUser: {
    userId: number;
    title: string;
    name: string;
    yearsExperience: number;
    activeOnPlatformSince: string;
    activeEngagementCount: number;
    feedbackRating: number;
    profilePicture: string;
  };

  @Attr() sectors: {
    sector_id: number;
    name: string;
    count: number;
  };

  @Attr() submissions: {
    submitted: number;
    timeToFirstSubmission: number;
    timeToHire: number;
    avgPerJobEngaged: number;
  };
  @Attr() jobs: {
    engaged: number;
    conversionRate: number;
    interviewRate: number;
    filled: number;
  };
  @Attr() fees: {
    paid: number;
    avgPaidPerJob: number;
  };
}

export default PslPerformance;
